<template>
  <div v-if="courses.length" class="banner d-flex flex-column flex-sm-row justify-end align-start align-sm-center pa-10 mb-4" :style="`background-image: url(${require('@/assets/dashboard-assets/cursoIA-background.png')}); background-size: cover; background-position: center;`" :class="{'pa-16': $vuetify.breakpoint.mobile}">
    <div class="mr-auto">
      <img src="@/assets/dashboard-assets/cursoIA-robot.png" alt="Robot IA" class="robot-image">
    </div>
    <div class="ml-16 d-flex flex-column justify-center align-center flex-grow-1" style="position: relative;">
      <div class="ml-16" style="position: relative; z-index: 1;">
        <div>
          <p class="font-weight-bold mb-1">{{ $t('modules.portalalumno.dashboard.banners.cursoIa.firstText') }}</p>
          <div style="font-size: 15px; line-height: 1.1">{{ $t('modules.portalalumno.dashboard.banners.cursoIa.secondText') }}</div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-sm-end align-center mt-6 mt-sm-0">
      <v-btn color="secondary" rounded @click="redirect">
        {{ $t('modules.portalalumno.dashboard.banners.cursoIa.showDetail') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { $course } from '../../Services'

export default {
  name: 'CourseBanner',
  computed: {
    ...mapGetters({
      studentCareerId: 'commons/getStudentActualRegister',
    }),
  },
  data() {
    return {
      courses: []
    }
  },
  created() {
    this.getCourses()
  },
  methods: {
    redirect() {
      this.$trackEvent('Home', 'Clk_BtnBnrIrCursoIA_Home', 'Banner_Course')
      this.$router.push('/academic-charge/subjects')
    },
    async getCourses() {
      const { data } = await $course.find('inscription', null, { params: { studentCareerId: this.studentCareerId } })
      this.courses = data
    },
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

.banner {
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  color: white;
  font-size: 1.25rem;
  font-family: 'Poppins', sans-serif;
  position: relative;
  overflow: hidden;
  min-height: 15vh;
}

@media screen and (max-width: 600px) {
  .banner {
    position: relative;
    min-height: 15vh;
    overflow: hidden;
  }
}

.robot-image {
  width: 10vw;
  max-height: auto;
  position: absolute;
  top: 2.5%;
  left: 2.5%;
  z-index: 0;
}

@media screen and (max-width: 600px) {
  .banner {
    position: relative;
    min-height: 60vh;
    padding: 20px !important;
  }
  
  .robot-image {
    width: 80%;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;
    z-index: 0;
  }
  
  .ml-16 {
    position: absolute;
    z-index: 1;
    text-align: left;
    margin-top: 30%;
    left: -25%;
  }
  
  .d-flex {
    position: relative;
    z-index: 1;
    justify-content: flex-start;
    width: 80%;
    left: 0;
  }
  
  .d-flex div {
    width: 100%;
  }
}
</style>
